const typesOptions = [
	{ key: "Texto", text: "Texto", value: "Text" },
	{ key: "Imagen", text: "Imagen", value: "Image" },
	{ key: "Archivo", text: "Archivo", value: "Document" },
	{ key: "Video", text: "Video", value: "Video" },
	// { key: "Audio", text: "Audio", value: "Audio" },
];

export default typesOptions;
